
<template>
    <div class="regenpassword">
        <v-container>
          <v-row class="text-center" align="center" align-self="center">

            <v-col md="6" offset-md="3">
              <v-card class="overflow-hidden mt-12" >
                  <v-toolbar flat color="secondary">

                    <v-toolbar-title class="font-weight-light white--text" >
                      {{$t('administration.user.initpassword')}}
                    </v-toolbar-title>
                  </v-toolbar>
                  <v-card-subtitle>
                    {{$t('administration.user.initpasswordmessage')}}
                  </v-card-subtitle>

                  <RegenPasswordForm class="pa-6" ref="RegenPasswordForm" :values="item" :errors="violations" />
                  <v-divider></v-divider>
                  <v-card-actions class="pa-6">
                      <v-spacer></v-spacer>
                      <v-btn
                        @click="initPassword"
                        color="primary"
                      >
                        {{$t('global.update')}}
                      </v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
       </v-container>
       <Loading :visible="isLoading" />
    </div>
</template>
<script>
  import { createHelpers } from 'vuex-map-fields';
  import { mapActions, mapState } from 'vuex';
  import RegenPasswordForm from '../../components/login/RegenPassword.vue';
  import Loading from '../../components/Loading';
  import NotificationMixin from '../../mixins/NotificationMixin';

  const servicePrefix = 'User';

  const { mapFields } = createHelpers({
    getterType: 'user/getField',
    mutationType: 'user/updateField'
  });

  export default {
    name: 'PasswordTurnover',
    servicePrefix,
    mixins: [NotificationMixin],
    components: {
      Loading,
      RegenPasswordForm
    },
    computed: {
      ...mapFields(['error', 'isLoading', 'created', 'violations']),
      ...mapState('user', {
        actioned: 'actioned',
        action: 'action',
        error: 'error',
        isLoading: 'isLoading',
      })
    },
    data() {
      return {
        item: {}
      };
    },
    created: function(){
    },
    methods: {
      initPassword() {

        const RegenPasswordForm = this.$refs.RegenPasswordForm;
        RegenPasswordForm.$v.$touch();
        let action = 'new_password/'+this.$route.params.id+'/'+this.$route.params.token;
        if (!RegenPasswordForm.$v.$invalid) {
          this.userPushAction({action: action,values: { 'plainPassword' : RegenPasswordForm.$v.item.$model.plainPassword}});
        } else {
          console.log('error');
        }
      },
      ...mapActions({
        userPushAction: 'user/action'
      }),

      initedPassword(item) {
        this.$router.push({ name: `Login` });
        console.log("initPassword");
        this.showMessage(item.message);
      },

    },
    watch: {
      actioned(actioned) {
        if (!actioned) {
          return;
        }
        let action = 'new_password/'+this.$route.params.id+'/'+this.$route.params.token;
        if (this.action == action) {
          this.initedPassword(actioned);
        }
      },

      error(message) {
        if (message != 'NotConnected') {
          message && this.showError(message);
        }
      }
    }
  }
</script>
